(function($, window, document, s, undefined) {

  var collapseBreakpoint = 830;  // this must match the sass variable
  var winWidth = 0;
  var $mainNav = null;
  var $colWrapper = null;
  var topLevelLink = null;


  var resizeHandler = function resizeHandler() {
    winWidth = s.$win.width();
    $topLevelLink.removeClass('active');
  };


  var initMainNav = function initMainNav() {
    if (!($mainNav && $colWrapper && $topLevelLink)) {
      $mainNav = s.$doc.find('#main-nav');
      $colWrapper = $('#site-header .collapsed-wrapper');
      $topLevelLink = $('#main-nav .with-submenu .top-level-link');
    }

    if (navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i)) {
      $colWrapper.addClass('ios7');
    }

    resizeHandler();

    $topLevelLink.on('click', activateMainNavLink);

    s.$doc.on('click', '#main-nav .collapsed-menu-toggle, #main-nav .close-btn', toggleCollapsedMenu);

  };


  var toggleCollapsedMenu = function toggleCollapsedMenu(e) {
    e.preventDefault();

    if ($colWrapper.hasClass('visible')) {
      $colWrapper.removeClass('visible');
    } else {
      $colWrapper.addClass('visible');
    }
  };


  var activateMainNavLink = function activateMainNavLink(e) {
    e.preventDefault();

    var $this = $(e.target);

    $this
      .parent()
      .siblings('.with-submenu')
        .find('.top-level-link.active').removeClass('active');

    $this.toggleClass('active');
  };


  s.callOnReady(initMainNav);
  s.callOnResize(resizeHandler);

})(jQuery, this, this.document, window.s);
